/**
 *
 * @param {Function} func Function to be excecuted
 * @param {Number} time Time to wait before firing
 * @param {Boolean} immediate Immediate mode
 */
export function debounce(func, time, immediate = false) {
  let timeout;
  return (...args) => {
    const later = () => {
      timeout = null;
      if (!immediate) func.apply(this, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, time);
    if (callNow) func.apply(this, args);
  };
}

export function chunk(arr, n) {
  return new Array(Math.ceil(arr.length / n))
    .fill()
    .map((_, i) => arr.slice(i * n, i * n + n));
}

/* eslint-disable no-param-reassign */
export function chunkify(arr, n) {
  if (n < 2) return [arr];

  const len = arr.length;
  const out = [];

  let i = 0;
  let size;
  if (len % n === 0) {
    size = Math.floor(len / n);

    while (i < len) {
      out.push(arr.slice(i, (i += size)));
    }

    return out;
  }

  n -= 1;
  size = Math.floor(len / n);

  if (len % size === 0) size -= 1;

  while (i < size * n) {
    out.push(arr.slice(i, (i += size)));
  }

  out.push(arr.slice(size * n));
  return out;
}
